"use client";

/**
 * Visual filtering funnel visualization.
 *
 * Extracted from `compass-intake.jsx:635-642` (`.cs-funnel`, `.cs-fstep`, `.cs-fbar` classes).
 * Renders a stepped funnel where each bar is proportionally sized.
 */

export interface FunnelStep {
  /** Width as a percentage (0-100). */
  width: number;
  /** Numeric count displayed on the bar. */
  count: number;
  /** Label below the bar. */
  label: string;
}

export interface FunnelProps {
  /** Steps in the funnel, widest to narrowest. */
  steps: FunnelStep[];
}

/**
 * Horizontal funnel chart: stacked bars shrinking from top to bottom.
 *
 * `.cs-funnel` → flex col, items-center, gap
 * `.cs-fstep`  → full width, flex col, items-center
 * `.cs-fbar`   → variable width bar, bg-brand-navy, rounded
 */
export function Funnel({ steps }: FunnelProps) {
  return (
    <div className="flex flex-col items-center gap-[6px] py-[8px]">
      {steps.map((step, i) => (
        <div key={i} className="w-full flex flex-col items-center gap-[4px]">
          {/* Bar */}
          <div
            className={[
              "h-[28px] rounded-(--radius-sm)",
              "flex items-center justify-center",
              "text-[12px] font-bold text-white",
              "transition-all duration-300",
              i === 0
                ? "bg-(--brand-navy)"
                : i === steps.length - 1
                  ? "bg-(--accent-cobalt)"
                  : "bg-(--steel-80)",
            ].join(" ")}
            style={{ width: `${step.width}%` }}
          >
            {step.count}
          </div>
          {/* Label */}
          <span className="text-[11px] text-(--fg-muted) text-center">
            {step.label}
          </span>
        </div>
      ))}
    </div>
  );
}
